export enum CpuFlag
{
    Carry            = 1 << 0, // C: Set if last operation caused an overflow/underflow
    Zero             = 1 << 1, // Z: Set if last operation resulted in 0
    InterruptDisable = 1 << 2, // I: Blocks hardware interrupts (IRQs) when set
    DecimalMode      = 1 << 3, // D: Unused on NES, but instructions still flip it
    Break            = 1 << 4, // B: Set when a BRK instruction is executed
    Unused           = 1 << 5, // U: Always reads as 1 on physical hardware
    Overflow         = 1 << 6, // V: Set if an arithmetic operation overflowed signed bounds
    Negative         = 1 << 7, // N: Set if the result of the last operation was negative (bit 7 is 1)
}
